<script setup lang="ts">
import StatementSummaryCard from '@/components/dashboard/home/StatementSummaryCard.vue'
import StatementYearPanel from '@/components/dashboard/statements/StatementYearPanel.vue'
import type { DonorFinancialYear } from '@/types/donorFinancialYear'
import type { UserStatement } from '@/types/userStatement'

defineProps<{
  financialYear: DonorFinancialYear
  issuedStatement?: UserStatement | null
  isPaid: boolean
}>()

const emit = defineEmits<{
  upgrade: []
}>()
</script>

<template>
  <StatementYearPanel
    v-if="isPaid"
    :financial-year="financialYear"
    :issued-statement="issuedStatement"
    show-tag
  />
  <StatementSummaryCard
    v-else
    :year="financialYear"
    show-upgrade-gate
    @upgrade="emit('upgrade')"
  />
</template>
